import { Component, Injectable } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { DialogResult } from '@app/Common/popup/dialog-result';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

export type JsonExtraValidator = (parsedJson: unknown) => string | null;

@Component({
    selector: 'json-editor',
    templateUrl: './json-editor.component.html',
    styleUrls: ['./json-editor.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatFormField, MatInput, FormsModule, MatButton]
})

@Injectable()
export class JsonEditorComponent {
    dialogTitle: string;
    dialogDescription = 'WARNING - Developer mode only';
    readonlyDescription = 'WARNING - Readonly mode';
    dialogConfirmButtonText = 'Save';
    dialogCancelButtonText = 'Cancel';
    dialogCodeArea: string;
    validationError: string;
    releaseNotes = '';
    readonly = false;
    extraValidator?: JsonExtraValidator;

    private dialogResult: DialogResult = new DialogResult();

    constructor(private dialogRef: MatDialogRef<JsonEditorComponent>) {}

    save(): void {
        if (this.readonly) {
            this.validationError = 'The JSON editor is readonly';
            return;
        }

        if (!this.jsonIsValid()) {
            this.validationError = 'The text above is not valid JSON';
            return;
        }

        if (this.extraValidator) {
            let extraError: string | null;
            try {
                extraError = this.extraValidator(JSON.parse(this.dialogCodeArea));
            } catch (e) {
                console.error('Extra validator threw; blocking save.', e);
                this.validationError = 'Unable to validate the JSON content';
                return;
            }
            if (extraError) {
                this.validationError = extraError;
                return;
            }
        }

        this.dialogResult.Result = true;
        this.dialogResult.Text = this.dialogCodeArea;
        this.dialogResult.Payload = this.releaseNotes;
        this.dialogRef.close(this.dialogResult);
    }

    cancel(): void {
        this.dialogResult.Result = false;
        this.dialogRef.close(this.dialogResult);
    }

    clearValidation(): void {
        this.validationError = '';
    }

    private jsonIsValid(): boolean {
        try {
            JSON.parse(this.dialogCodeArea);
        } catch (e) {
            return false;
        }

        return true;
    }

    protected readonly close = close;
}
